/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
export type SbSharedTrackingContainer_itemSearch$ref = any;
export type SbSharedTrackingContainer_itemSearch = {
    readonly topCategoryL1: VerticalType | null;
    readonly pageType: string | null;
    readonly totalResults: number | null;
    readonly displayUriRef: string | null;
    readonly browseContentModule: {
        readonly moduleType: string | null;
    } | null;
    readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
        readonly values: ReadonlyArray<{
            readonly displayName: string | null;
            readonly urlLabel: string | null;
            readonly code: string | null;
        } | null> | null;
    } | null> | null;
    readonly sort: {
        readonly currentOption: {
            readonly urlLabel: string | null;
        } | null;
    } | null;
    readonly categoryTiles: ReadonlyArray<{
        readonly displayName: string | null;
    } | null> | null;
    readonly " $refType": SbSharedTrackingContainer_itemSearch$ref;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "displayName",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "urlLabel",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "SbSharedTrackingContainer_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "contentModuleId",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "topCategoryL1",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "pageType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "totalResults",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "displayUriRef",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "browseContentModule",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "contentModuleId",
          "variableName": "contentModuleId"
        }
      ],
      "concreteType": null,
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "moduleType",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "appliedFilters",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "values",
          "storageKey": null,
          "args": null,
          "concreteType": "SearchBrowseParsedParamValue",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "code",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "sort",
      "storageKey": null,
      "args": null,
      "concreteType": "SortType",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "currentOption",
          "storageKey": null,
          "args": null,
          "concreteType": "SearchBrowseSortCurrentOption",
          "plural": false,
          "selections": [
            (v1/*: any*/)
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "categoryTiles",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseCategoryTiles",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ]
    }
  ]
};
})();
(node as any).hash = '844c9168901d49aef2e9b94e0dbe280a';
export default node;
